import React from 'react';

const TeamsContentSkeleton: React.FC = () => {
  return (
    <div className="min-h-screen  rounded-2xl dark:bg-secondary-dark">
      <div className="px-6 py-6">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center">
            <div className="h-6 bg-gray-300 dark:bg-gray-600 rounded w-40 animate-pulse"></div>
          </div>

          <div className="flex items-center ml-4">
            <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-28 mr-3 animate-pulse"></div>
            <div className="w-12 h-6 bg-gray-300 dark:bg-gray-600 rounded-full animate-pulse"></div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-3 gap-8">
          {[...Array(9)].map((_, index) => (
            <div key={index} className="relative h-full">
              <div className="group h-full bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 transition-all duration-300 overflow-hidden">
                <div className="p-4">
                  <div className="flex items-start justify-between mb-6">
                    <div className="flex items-center gap-4 w-full">
                      <div className="relative flex-shrink-0">
                        <div className="w-12 h-12 bg-gray-300 dark:bg-gray-600 rounded-xl border-2 border-gray-300 dark:border-gray-600 animate-pulse"></div>
                        <div className="absolute -top-1 -right-1 w-4 h-4 rounded-full bg-gray-300 dark:bg-gray-600 border-2 border-white dark:border-gray-800 animate-pulse"></div>
                      </div>

                      <div className="flex-1 min-w-0 max-w-[calc(100%-120px)] pr-3">
                        <div className="h-5 bg-gray-300 dark:bg-gray-600 rounded w-40 mb-2 animate-pulse"></div>
                        <div className="flex flex-wrap gap-1">
                          <div className="h-5 bg-gray-300 dark:bg-gray-600 rounded-full w-24 animate-pulse"></div>
                          <div className="h-5 bg-gray-300 dark:bg-gray-600 rounded-full w-20 animate-pulse"></div>
                        </div>
                      </div>
                    </div>

                    <div className="flex items-center gap-2">
                      <div className="w-4 h-4 bg-gray-300 dark:bg-gray-600 rounded animate-pulse"></div>
                    </div>
                  </div>

                  <div className="space-y-4">
                    <div className="flex items-center justify-between">
                      <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-28 animate-pulse"></div>
                    </div>

                    <div className="flex items-center">
                      <div className="flex -space-x-3">
                        {[1, 2, 3, 4, 5].map((memberIndex) => (
                          <div
                            key={memberIndex}
                            className="w-10 h-10 bg-gray-300 dark:bg-gray-600 rounded-full border-3 border-white dark:border-gray-800 animate-pulse"
                            style={{ zIndex: 10 - memberIndex }}
                          ></div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="absolute inset-0 bg-blue-50/20 dark:bg-blue-900/10 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none rounded-xl"></div>
            </div>
          ))}
        </div>

        <div className="text-center py-16 hidden">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-yellow-400/20 to-orange-500/20 rounded-2xl mb-4">
            <div className="w-8 h-8 bg-gray-300 dark:bg-gray-600 rounded animate-pulse"></div>
          </div>
          <div className="h-5 bg-gray-300 dark:bg-gray-600 rounded w-64 mb-2 animate-pulse mx-auto"></div>
          <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-96 animate-pulse mx-auto"></div>
        </div>
      </div>
    </div>
  );
};

export default TeamsContentSkeleton; 